export function toCalendarDate(dateValue) {
	if (!dateValue) return null;
	if (dateValue instanceof Date) return dateValue;
	if (typeof dateValue === 'object' && dateValue.creation_date !== undefined) {
		return new Date(Number(dateValue.creation_date) * 1000);
	}
	if (typeof dateValue === 'string') {
		const match = dateValue.match(/^(\d{2})-(\d{2})-(\d{4})$/);
		if (match) {
			return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
		}
	}
	return new Date(dateValue);
}

export function formatCalendarDate(dateValue) {
	const date = toCalendarDate(dateValue);
	if (!date || isNaN(date.getTime())) return null;

	const day = date.getDate().toString().padStart(2, '0');
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const year = date.getFullYear();
	return `${day}-${month}-${year}`;
}

export function resolveCreationDate(dateValue, availableDates = []) {
	if (!dateValue) return null;
	if (typeof dateValue === 'object' && dateValue.creation_date !== undefined) {
		return Number(dateValue.creation_date);
	}
	if (typeof dateValue === 'number' && Number.isFinite(dateValue)) {
		return dateValue;
	}
	if (typeof dateValue === 'string' && /^\d+$/.test(dateValue)) {
		return Number(dateValue);
	}

	const selectedDate = toCalendarDate(dateValue);
	if (!selectedDate || isNaN(selectedDate.getTime())) return null;

	const selectedDay = selectedDate.toDateString();
	const matchedDate = availableDates.find(dateObj => {
		const creationDate = Number(
			typeof dateObj === 'object' && dateObj !== null && dateObj.creation_date !== undefined
				? dateObj.creation_date
				: dateObj
		);
		if (!Number.isFinite(creationDate)) return false;
		return new Date(creationDate * 1000).toDateString() === selectedDay;
	});

	if (matchedDate === undefined) return null;
	return Number(
		typeof matchedDate === 'object' && matchedDate !== null && matchedDate.creation_date !== undefined
			? matchedDate.creation_date
			: matchedDate
	);
}
